module.exports = "/assets/7f91a092c737a1f360eb14391d541630.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/LP.png
// module id = 1587
// module chunks = 0